<template>
  <div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col>
          <card>
            <b-row align-v="center" slot="header">
              <b-col cols="8">
                <h3 class="mb-0">Cadastro de Peça de Estudante</h3>
              </b-col>
              <b-col cols="4" v-loading="loading" />
            </b-row>

            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <b-form @submit.prevent="handleSubmit(save)" v-loading="loading">
                <!-- Informações do Grupo -->
                <h6 class="heading-small text-muted mb-4">
                  Informações do Grupo
                </h6>
                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Nome do Grupo"
                        name="Nome do Grupo"
                        placeholder="Digite o nome do grupo"
                        v-model="peca.grupo"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Universidade"
                        name="Universidade"
                        placeholder="Digite o nome da universidade"
                        v-model="peca.universidade"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <div class="form-group">
                        <validation-provider
                          :rules="{ required: true }"
                          name="Categoria"
                          v-slot="{ errors }"
                        >
                          <label class="form-control-label">Categoria</label>
                          <b-form-select
                            class="shadow-none"
                            v-model="peca.idCategoriaPecaEstudante"
                            name="Categoria"
                            :options="categorias"
                            :state="errors[0] ? false : null"
                          />

                          <slot name="error">
                            <div
                              v-if="errors[0]"
                              class="invalid-feedback"
                              style="display: block"
                            >
                              {{ errors[0] }}
                            </div>
                          </slot>
                        </validation-provider>
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <hr class="my-4" />
                <!-- Participantes -->
                <h6 class="heading-small text-muted mb-4">
                  Participantes (mínimo 3, máximo 6)
                </h6>

                <b-card
                  class="mb-4"
                  v-for="(part, index) in peca.detalhesEstudante"
                  v-bind:key="part.id"
                >
                  <b-card-title class="d-flex justify-content-between">
                    Participante {{ index + 1 }}
                    <base-button
                      size="sm"
                      type="danger"
                      v-if="peca.detalhesEstudante.length > 1"
                      @click="excluirParticipante(index)"
                      >Excluir</base-button
                    >
                  </b-card-title>

                  <div class="pl-lg-4">
                    <b-row>
                      <b-col lg="6">
                        <base-input
                          type="text"
                          label="Nome Completo"
                          name="Nome Completo"
                          placeholder="Digite o nome completo do participante"
                          v-model="peca.detalhesEstudante[index].nome"
                        >
                        </base-input>
                      </b-col>
                      <b-col lg="6">
                        <base-input
                          type="text"
                          label="RA"
                          name="RA"
                          placeholder="Digite o RA do participante"
                          v-model="peca.detalhesEstudante[index].ra"
                        >
                        </base-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="6">
                        <base-input
                          type="text"
                          label="Telefone"
                          name="Telefone"
                          placeholder="Digite o telefone do participante"
                          v-model="peca.detalhesEstudante[index].telefone"
                        >
                        </base-input>
                      </b-col>
                      <b-col lg="6">
                        <base-input
                          type="email"
                          label="E-mail"
                          name="E-mail"
                          placeholder="Digite o e-mail do participante"
                          v-model="peca.detalhesEstudante[index].email"
                        >
                        </base-input>
                      </b-col>
                    </b-row>
                  </div>
                </b-card>

                <div
                  class="d-flex justify-content-center"
                  v-if="peca.detalhesEstudante.length < 6"
                >
                  <base-button type="neutral" @click="addParticipante"
                    >Adicionar Participante</base-button
                  >
                </div>

                <hr class="my-4" />
                <!-- Coordenador do Curso -->
                <h6 class="heading-small text-muted mb-4">
                  Coordenador do Curso
                </h6>
                <div class="pl-lg-4">
                  <b-row>
                    <b-col lg="12">
                      <base-input
                        type="text"
                        label="Nome Completo"
                        name="Nome Completo"
                        placeholder="Digite o nome completo do coordenador do curso"
                        v-model="peca.nomeCoordenador"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="E-mail"
                        name="E-mail"
                        placeholder="Digite o e-mail do coordenador do curso"
                        v-model="peca.emailCoordenador"
                      >
                      </base-input>
                    </b-col>
                    <b-col lg="6">
                      <base-input
                        type="text"
                        label="Telefone"
                        name="Telefone"
                        placeholder="Digite o telefone do coordenador do curso"
                        v-model="peca.telefoneCoordenador"
                      >
                      </base-input>
                    </b-col>
                  </b-row>
                </div>

                <hr class="my-4" />
                <!-- Coordenador do Curso -->
                <h6 class="heading-small text-muted mb-4">Peça</h6>
                <div v-if="!idEdit" class="pl-lg-4" id="upload-arquivos">
                  <b-row>
                    <b-col lg="12">
                      <label class="form-control-label">Peça</label>

                      <validation-provider
                        rules="required|size:10240"
                        name="Peça"
                        v-slot="{ validate, errors }"
                      >
                        <b-form-file
                          v-model="fileUpload1"
                          placeholder="Escolha um arquivo ou arraste ele aqui..."
                          browse-text="Escolher arquivo"
                          drop-placeholder="Arraste o arquivo aqui..."
                          @change="validate"
                          :state="errors[0] ? false : null"
                        ></b-form-file>
                        <slot name="error">
                          <div
                            v-if="errors[0]"
                            class="invalid-feedback"
                            style="display: block"
                          >
                            {{ errors[0] }}
                          </div>
                        </slot>
                      </validation-provider>
                      <div class="text-muted mt-1">
                        Tipo de arquivo permitido: PDF - Tamanho máximo: 10MB
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div v-else class="pl-lg-4" id="visualizar-arquivos">
                  <b-row>
                    <b-col lg="12">
                      <div class="form-group">
                        <label class="form-control-label">Peça</label>
                        <div>
                          <a
                            :href="
                              '/uploads/' + DEPLOYED_YEAR + '/' + peca.arquivo
                            "
                            class="btn btn-sm btn-info"
                            target="_blank"
                            v-if="peca.arquivo"
                          >
                            Ver Peça
                          </a>
                          <span
                            class="
                              form-control-label
                              text-muted
                              font-weight-normal
                            "
                            v-else
                            >(Vazio)</span
                          >
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <hr class="my-4" />
                <div
                  class="pl-lg-4 d-flex justify-content-end align-items-center"
                >
                  <span class="text-danger mr-3">{{ errorFeedback }}</span>
                  <base-button
                    type="primary"
                    native-type="submit"
                    :loading="loading"
                    class="my-4"
                  >
                    <span v-if="!idEdit">Cadastrar</span>
                    <span v-else>Salvar</span>
                  </base-button>
                </div>
              </b-form>
            </validation-observer>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import api, { getRequestErrorMessage } from "@/services/api";
import { DEPLOYED_YEAR } from "@/util/constants";

export default {
  data() {
    return {
      DEPLOYED_YEAR,
      errorFeedback: "",
      loading: false,
      idEdit: null,
      categorias: [],
      fileUpload1: null,
      peca: {
        arquivo: "",
        detalhesEstudante: [
          {
            email: "",
            nome: "",
            ra: "",
            telefone: "",
          },
        ],
        emailCoordenador: "",
        grupo: "",
        id: "",
        idCadastroEstudante: "",
        idCategoriaPecaEstudante: null,
        nomeCoordenador: "",
        telefoneCoordenador: "",
        universidade: "",
      },
    };
  },
  methods: {
    async save() {
      this.errorFeedback = "";
      this.loading = true;

      if (this.fileUpload1 && !this.idEdit) {
        await this.saveFile(this.fileUpload1).then((fileName) => {
          this.peca.arquivo = fileName;
        });
      }
      try {
        await api.post("/peca-estudante", this.peca);
        this.$router.push("/usuario");
      } catch (e) {
        this.throwError();
      } finally {
        this.loading = false;
      }
    },
    addParticipante() {
      const newEstudante = {
        email: "",
        nome: "",
        ra: "",
        telefone: "",
      };
      this.peca.detalhesEstudante.push(newEstudante);
    },
    excluirParticipante(index) {
      this.peca.detalhesEstudante.splice(index, 1);
    },
    async saveFile(file) {
      if (file) {
        const dataForm = new FormData();
        dataForm.append("file", file);
        try {
          const response = await api.post("/file/upload", dataForm);
          if (
            response.data.filesUploaded &&
            response.data.filesUploaded.length > 0
          ) {
            return response.data.filesUploaded[0];
          } else {
            this.loading = false;
            this.throwError("Ocorreu um problema ao subir os arquivos.");
            throw new Error("Ocorreu um problema ao subir os arquivos.");
          }
        } catch (e) {
          this.loading = false;
          const msg = getRequestErrorMessage(
            e,
            "Ocorreu um problema ao subir os arquivos."
          );
          this.throwError(msg);
          throw new Error(msg);
        }
      } else {
        return "";
      }
    },
    throwError(msg) {
      this.errorFeedback =
        msg || "Ocorreu um problema. Por favor, tente novamente mais tarde.";
    },
    async loadCategorias() {
      const response = await api.get("/categoria-peca-estudante");
      const categoriasFiltered = response.data.data
        .filter((cat) => cat.ativo)
        .sort((a, b) => a.posicao - b.posicao);

      const categorias = categoriasFiltered.map((cat) => ({
        value: cat.id,
        text: cat.nome,
      }));
      categorias.unshift({ value: null, text: "Selecione uma categoria..." });

      this.categorias = categorias;
    },
  },
  async mounted() {
    this.idEdit = this.$route.params.id;

    if (this.idEdit) {
      this.loading = true;
      this.loadCategorias();
      try {
        const response = await api.get(`/peca-estudante/${this.idEdit}`);
        this.peca = response.data;
      } catch (e) {
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao carregar os dados. Por favor, tente novamente mais tarde."
        );
      } finally {
        this.loading = false;
      }
    } else {
      const { details } = JSON.parse(localStorage.getItem("user@mf"));

      const emptyEstudante = [
        {
          email: "",
          nome: "",
          ra: "",
          telefone: "",
        },
      ];
      if (details.id) {
        this.peca.idCadastroEstudante = details.id;
        this.peca.grupo = details.nomeGrupo;
        this.peca.universidade = details.universidade;
        this.peca.detalhesEstudante =
          details.detalhesEstudante || emptyEstudante;
        this.peca.nomeCoordenador = details.nomeCoordenador;
        this.peca.emailCoordenador = details.emailCoordenador;
        this.peca.telefoneCoordenador = details.telefoneCoordenador;
      }

      this.loadCategorias();
    }
  },
};
</script>
<style></style>
